import { Grid2, Typography } from "@mui/material";
import { MEAL_SCHEDULE } from "../../constants";
import styles from './AddNotesSelectMealType.module.css'
import { ButtonBase } from "@mui/material";

const AddNotesSelectMealType = ({selectedMealType, setSelectedMealType}: {selectedMealType: string, setSelectedMealType: React.Dispatch<React.SetStateAction<string>> }) => {
    const handleChangeMealType = (mealType: string) =>{
        if(selectedMealType !== mealType){
            setSelectedMealType(mealType)
        }
    }
    return (
        <Grid2 className={styles.meal_time_container}>
            {MEAL_SCHEDULE.map((meal) => {
                const { mealType } = meal;
                const isMealTypeActive = mealType.toLowerCase() === selectedMealType.toLowerCase()
                return (
                    <ButtonBase
                        className={`${styles.meal_time_button} ${isMealTypeActive ? styles.meal_time_button_active : ''}`}
                        key={mealType}
                        onClick={() =>handleChangeMealType(mealType)}
                    >
                        <Typography className={styles.meal_type_text} variant="caption4LightOutfit">
                            {mealType}
                        </Typography>
                    </ButtonBase>
                );
            })}
        </Grid2>
    );
}

export default AddNotesSelectMealType